import { ProductType } from '@hc-frontend/core-types';

const healthcareProductTypes: Record<ProductType, 1 | 2 | 3> = {
  [ProductType.Enum.HEALTH]: 1,
  [ProductType.Enum.MEDICARE]: 2,
  [ProductType.Enum.MEDICARE_ADVANTAGE]: 2,
  [ProductType.Enum.LIFE_INSURANCE]: 3,
};

export function productTypeToHealthcare(productType: ProductType) {
  return healthcareProductTypes[productType];
}
